import { CachedUser, UserType } from "@/features/user/types";
import { Linked_companies_jwt, userState } from "@/models/user";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  expirationDate: null,
  roles: [],
  linked_companies: {},
  userWithFullname: null
} satisfies userState as userState;

export const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    setRoles: (state, action: PayloadAction<{ roles: string[] }>) => {
      state.roles = action.payload.roles;
    },
    setLinkedCompanies: (
      state,
      action: PayloadAction<{ linkedCompanies: Linked_companies_jwt }>
    ) => {
      state.linked_companies = action.payload.linkedCompanies;
    },
    setExpirationToken: (state, action: PayloadAction<number | null>) => ({
      ...state,
      expirationDate: action.payload
    }),
    setUser: (state, action: PayloadAction<UserType | null>) => ({
      ...state,
      user: action.payload
    }),
    setUserWithFullname: (state, action: PayloadAction<CachedUser | null>) => ({
      ...state,
      userWithFullname: action.payload
    }),
    setUserWithFullnameEmail: (state, action: PayloadAction<string | undefined>) => ({
      ...state,
      userWithFullname: { ...state.userWithFullname, email: action.payload }
    }),
    resetState: () => initialState
  },
  selectors: {
    getUserRoles: (state): string[] => state.roles,
    getListOfCompanies: (state): Linked_companies_jwt => state.linked_companies,
    getUserWithFullname: (state): CachedUser | null => {
      return state.userWithFullname;
    },
    getUser: (state): UserType | null => {
      return state.user;
    },
    getExpirationDate: (state): number | null => {
      return state.expirationDate;
    }
  }
});

export const {
  setUser,
  setExpirationToken,
  setUserWithFullname,
  setUserWithFullnameEmail,
  setLinkedCompanies,
  setRoles
} = userSlice.actions;

export const { getUser, getExpirationDate, getUserWithFullname, getUserRoles, getListOfCompanies } =
  userSlice.selectors;
